import { IGetAtividadeObraCorresponsavelDropDownUseCase } from "../../../presentation/useCases/read/get_atividade_obra_corresponsavel_drop_down_use_case";
import { AtividadeObraFuncionario } from "../../models/atividade_obra_funcionario";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAtividadeObraCorresponsavelDropDownUseCase
 */

export class GetAtividadeObraCorresponsavelDropDownUseCase implements IGetAtividadeObraCorresponsavelDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getAtividadeObraCorresponsavelDropdown(
    idFuncionarioResponsavel?: number,
  ): Promise<AtividadeObraFuncionario[]> {
    return await this.repository.getAtividadeObraCorresponsavelDropdown(idFuncionarioResponsavel ?? null);
  }
}
